import Services from "services";

class StockFisikApi {
  alreadyStockOpname(params) {
    return Services.get("stock_opname/cek", { params });
  }
}

export default new StockFisikApi();
